module.exports = __webpack_public_path__ + "static/media/key.da04e129.svg";